import React from 'react';
import { motion } from 'framer-motion';
import { LockClosedIcon } from '@heroicons/react/24/outline';

interface GenericDenialMessageProps {
  featureName: string;
  reason: string;
}

/**
 * Generic denial message component for unhandled access denial scenarios
 * Provides clear feedback when access is denied for non-specific reasons
 */
export const GenericDenialMessage: React.FC<GenericDenialMessageProps> = ({
  featureName,
  reason
}) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-xl p-8 max-w-md text-center"
      >
        <div className="w-16 h-16 mx-auto mb-4 bg-red-500/20 rounded-full flex items-center justify-center">
          <LockClosedIcon className="w-8 h-8 text-red-400" />
        </div>
        
        <h3 className="text-2xl font-bold text-white mb-2">
          Access Denied
        </h3>
        
        <p className="text-white/70 mb-2">
          You don't have access to <strong>{featureName}</strong>
        </p>
        
        <p className="text-white/50 text-sm">
          {reason}
        </p>
      </motion.div>
    </div>
  );
};

export default GenericDenialMessage;
